<div class="modal-header" [ngClass]="isSuccessMessage ? 'alert-success': 'alert-danger'">
  <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
    <span aria-hidden="true">×</span>
  </button>
  <h6 class="modal-title w-100">
    {{message}}
  </h6>
</div>